import * as React from "react";

function IcSystemLocationBloom(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemLocationBloom"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 10C4.75 7.68334 5.55609 5.88638 6.83092 4.66698C8.11093 3.44262 9.91684 2.75 12 2.75C14.0832 2.75 15.8891 3.44262 17.1691 4.66698C18.4439 5.88638 19.25 7.68334 19.25 10C19.25 11.5389 18.6562 12.8429 17.7532 14.0515C16.9584 15.1154 15.9606 16.0611 14.9534 17.0156L14.9534 17.0156C14.7983 17.1626 14.643 17.3098 14.4882 17.4576C13.6459 18.2621 12.8715 19.1647 12.3119 19.8594C12.1993 19.9992 12.0949 20.1311 12 20.2527C11.9051 20.1311 11.8007 19.9992 11.6881 19.8594C11.1285 19.1647 10.3541 18.2621 9.51178 17.4576C9.35697 17.3098 9.20168 17.1626 9.04661 17.0156C8.03943 16.0611 7.04165 15.1154 6.2468 14.0515C5.34385 12.8429 4.75 11.5389 4.75 10ZM11.3881 21.9336L11.3885 21.9342L11.3885 21.9343C11.5292 22.1323 11.7571 22.25 12 22.25C12.2429 22.25 12.4708 22.1323 12.6115 21.9343L12.6115 21.9342L12.6119 21.9336L12.6143 21.9303L12.625 21.9154L12.6691 21.8545C12.7083 21.8006 12.7668 21.721 12.8422 21.6203C12.9932 21.4188 13.2118 21.1333 13.48 20.8004C14.0188 20.1316 14.7475 19.2842 15.5242 18.5424C15.6713 18.402 15.8218 18.2594 15.9747 18.1147L15.9748 18.1146L15.9748 18.1146C16.9752 17.1675 18.0768 16.1246 18.9549 14.9493C19.9815 13.5751 20.75 11.9626 20.75 10C20.75 7.31666 19.8061 5.11362 18.2059 3.58302C16.6109 2.05738 14.4168 1.25 12 1.25C9.58316 1.25 7.38907 2.05738 5.79408 3.58302C4.19391 5.11362 3.25 7.31666 3.25 10C3.25 11.9626 4.01848 13.5751 5.04513 14.9493C5.92323 16.1246 7.02482 17.1675 8.02516 18.1146L8.02518 18.1146L8.02528 18.1147C8.17819 18.2594 8.32874 18.402 8.47576 18.5424C9.25249 19.2842 9.98123 20.1316 10.52 20.8004C10.7882 21.1333 11.0068 21.4188 11.1578 21.6203C11.2332 21.721 11.2917 21.8006 11.3309 21.8545L11.375 21.9154L11.3857 21.9303L11.3881 21.9336ZM12 5.75C9.92893 5.75 8.25 7.42893 8.25 9.5C8.25 11.5711 9.92893 13.25 12 13.25C14.0711 13.25 15.75 11.5711 15.75 9.5C15.75 7.42893 14.0711 5.75 12 5.75ZM9.75 9.5C9.75 8.25736 10.7574 7.25 12 7.25C13.2426 7.25 14.25 8.25736 14.25 9.5C14.25 10.7426 13.2426 11.75 12 11.75C10.7574 11.75 9.75 10.7426 9.75 9.5Z"
        fill={color}
      />
    </svg>
  );
}

export default IcSystemLocationBloom;
